

/**
 * @name ParticipantsController
 * @description Controller for participants
 * @param {service} Participants The Participants service
 * @param {service} Collector The Collector service
 * @param {service} Operators The Operators service
 * @param {service} Session The Session service
 * @param {library} moment The moment library
 * @param {service} $log The Angular $log service
 * @param {service} $q The Angular $q service
 * @param {service} $rootScope The Angular $rootScope service
 * @param {service} _ The Lodash library
 */
function ParticipantsController(
  Participants,
  Collector,
  Operators,
  Session,
  moment,
  $log,
  $q,
  $rootScope,
  _
) {
  let vm = this;

  vm.$onInit = function() {
    vm.participants = [];
    vm.possibleParticipants = [];
    vm.toggle = toggle;
    vm.session = Session;
    vm.isParticipantsCollapsed = true;
  };

  vm.$onChanges = function(changes) {
    if (!_.isUndefined(changes.conversationId) &&
    !_.isUndefined(changes.conversationId.currentValue) &&
    !_.isUndefined(vm.appointmentId)) {
      let conversationId = changes.conversationId.currentValue;
      get(conversationId, vm.appointmentId);
    } else if (!_.isUndefined(vm.appointmentId) &&
    !_.isUndefined(vm.conversationId)) {
      get(vm.conversationId, vm.appointmentId);
    }
  };

  /**
   * @name get
   * @description Function to get a list of participants
   * @param {number} conversationId The ID of the conversation to retrieve
   * @param {number} appointmentId The ID of the appointment for the
   * conversation
   */
  function get(conversationId, appointmentId) {
    let collectorId;
    Participants.get(conversationId, appointmentId, collectorId)
    .then(function(participants) {
      let promises = [];
      _.each(participants, function(participant) {
        let promise = Collector.getCollector(participant.collector)
        .then(function(collector) {
          participant.collector = collector;
          participant.active = true;
          participant.isArtist = false;
          participant.isProjectOwner = false;
          if (!_.isUndefined(vm.artist) && vm.artist !== null &&
          vm.artist.id === participant.collector.id) {
            participant.isArtist = true;
          }
          if (!_.isUndefined(vm.collector) &&
          vm.collector.id === participant.collector.id) {
            participant.isProjectOwner = true;
          }
          return participant;
        });
        promises.push(promise);
      });
      if (Session.activeState.role === 'operator') {
        let operatorsPromise =
        Operators.getAllForShop(Session.activeState.association.shop.id)
        .then(function(operators) {
          let newOperators = [];
          _.each(operators.confirmed, function(operator) {
            let newOperator = {
              collector: operator,
              isOperator: true,
              active: false
            };
            newOperator.isArtist = false;
            newOperator.isProjectOwner = false;
            if (!_.isUndefined(vm.artist) && vm.artist !== null &&
            newOperator.collector.id === vm.artist.id) {
              newOperator.isArtist = true;
            }
            if (!_.isUndefined(vm.collector) &&
            newOperator.collector.id === vm.collector.id) {
              newOperator.isProjectOwner = true;
            }
            newOperators.push(newOperator);
          });
          return newOperators;
        });
        promises.push(operatorsPromise);
      }

      // Get the results
      $q.all(promises).then(function(results) {
        let flatResults = _.union(_.flatten(results));
        vm.participants = _.uniqBy(flatResults, function(flatResult) {
          return flatResult.collector.id;
        });
        if (!_.isUndefined(vm.artist) && vm.artist !== null) {
          let hasArtist = _.some(vm.participants, function(participant) {
            return vm.artist.id === participant.collector.id;
          });
          if (!hasArtist) {
            vm.participants.push({
              isArtist: true,
              collector: vm.artist,
              active: false
            });
          }
        }
        let hasCollector;
        if (!_.isUndefined(vm.collector)) {
          hasCollector = _.some(vm.participants, function(participant) {
            return vm.collector.id === participant.collector.id;
          });
        }
        if (!hasCollector) {
          vm.participants.push({
            isProjectOwner: true,
            collector: vm.collector,
            active: false
          });
        }
        vm.totalParticipants = vm.participants.length;
        vm.activeParticipants =
        _.countBy(vm.participants, function(participant) {
          return participant.active;
        });
        if (_.isUndefined(vm.activeParticipants.true)) {
          vm.activeParticipants.true = 0;
        }
        $log.debug('All participants', vm.participants);
      });
    });
  }

  /**
   * @name toggle
   * @description Function to create or delete a participant
   * @param {array} participant The participate to create or delete
   */
  function toggle(participant) {
    if (participant.active === true) {
      // Delete the participant
      Participants.remove(participant.id).then(function() {
        get(vm.conversationId);
      });
    } else if (participant.active === false) {
      // Create a new participant
      let preparedParticipant = {
        role: Session.activeState.role,
        conversation_id: vm.conversationId,
        collector_id: participant.collector.id,
        appointment_id: vm.appointmentId,
        last_read_date: moment().format('YYYY-MM-DDTHH:mm:ss')
      };
      Participants.create(preparedParticipant).then(function() {
        get(vm.conversationId);
      });
    }
  }

  let deregister = $rootScope.$on('refresh-participants', function() {
    get(vm.conversationId, vm.appointmentId);
  });
  $rootScope.$on('$destroy', deregister);
}

angular
  .module('inkfinder')
  .controller('ParticipantsController', ParticipantsController);



// WEBPACK FOOTER //
// ./components/messages/participants/participants.controller.js